// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import { YYYYMMDDtoEpochInEST } from 'helpers/timeConversion'

const formatAdministration = a => {
  // ulsFileNumber can be an empty string.
  const ulsFileNumber = a.ulsFileNumber ? a.ulsFileNumber.trim() : null
  const expirationDate = YYYYMMDDtoEpochInEST(a.expirationDate)
  const licenseDate = YYYYMMDDtoEpochInEST(a.licenseDate)
  const publicNoticeDate = YYYYMMDDtoEpochInEST(a.publicNoticeDate)
  const segmentStatusId = castToFloat(a.segmentStatusId)

  return {
    expirationDate,
    licenseDate,
    publicNoticeDate,
    segmentStatusId,
    ulsFileNumber,
  }
}

export default formatAdministration
